import { Box, Typography, Container } from '@mui/material';

export const Footer = () => {
    return (
        <Box 
            component="footer"
            sx={{ 
                py: 3,
                mt: 'auto',
                borderTop: '1px solid',
                borderColor: 'divider',
                bgcolor: 'background.paper',
            }}
        >
            <Container maxWidth="xl">
                <Typography 
                    variant="caption" 
                    sx={{ 
                        color: 'text.disabled',
                        display: 'block',
                        textAlign: 'center',
                        letterSpacing: '0.05em',
                    }}
                >
                    © {new Date().getFullYear()} EOE.INK · Modified from zimu.live
                </Typography>
            </Container>
        </Box>
    );
}